import { CONFIG_STATUS_LEVEL } from '../../constants/integrationConstants/fieldMappingConstants';

export const getNotSelectedTicketStatus = (properties, ticketMapping) => {
  const selectedTicketStatus = Object.values(ticketMapping).flat();

  return properties
    .filter(({ id }) => !selectedTicketStatus.includes(id))
    .map(({ id }) => id);
};

export const getTicketStatusMappings = (ticketMapping) => {
  return Object.entries(ticketMapping).map(([key, value]) => ({
    [key]: value,
  }));
};

export const getMappings = (ticketMapping, properties, defaultkey) => {
  const notSelectedTicketStatus = getNotSelectedTicketStatus(
    properties,
    ticketMapping
  );

  const ticketStatusMappings = getTicketStatusMappings(ticketMapping);
  return ticketStatusMappings.map((obj) => {
    const [key] = Object.keys(obj);
    if (key === defaultkey) {
      return {
        velaris: key,
        vendor: obj[key].concat(notSelectedTicketStatus),
      };
    }
    return { velaris: key, vendor: obj[key] };
  });
};

export const ticketMappingStatusOnClear = (newTicketMapping) => {
  const status = Object.values(newTicketMapping.mapping).some(
    (statusArray) => statusArray.length > 0
  )
    ? CONFIG_STATUS_LEVEL.COMPLETED
    : CONFIG_STATUS_LEVEL.IN_PROGRESS;
  return status;
};

// get the properties for each headerkey ['high', 'medium' ..]
export const getPropertiesOptions = (
  properties,
  selectedProperties,
  ownOptionIdArray
) => {
  const availableOptions = properties.filter(
    (status) => !selectedProperties.includes(status.id)
  );
  const ownOptions = ownOptionIdArray
    .map((id) => properties.find((prop) => prop.id === id))
    .filter(Boolean);
  const options = [...availableOptions, ...ownOptions];
  return options;
};
